/**
 * @module experience/hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/*tslint:disable max-file-line-count*/
// Core
import {
  Component,
  Input,
  OnDestroy,
  Output,
  OnInit,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';

// Services
import { CompareHardgoodsService } from '@experience/shop/hardgoods/services/compare-hardgoods.service';

import { CommonUtilService } from '@support/shared/services/common-util.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
// Interfaces
import {
  CurrentDeviceDetails,
  DeviceDetails,
  ConditionalEnhancement,
} from '@experience/shop/hardgoods/interfaces/browse-hardgood.interface';
import { HardgoodsContent } from '@core/aem/interfaces/shop/browse-hardgoods.interface';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

// Constants
import {
  HARDGOODS_CONSTANTS,
  DIGITALDATA_CONSTANT,
} from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';
import { HARDGOODS_MODULE_COMPONENTS } from '@experience/shop/hardgoods/constants/hardgoods.constants';

import { Wove } from 'aspect.js/';
import { BrowseDeviceModel } from '@experience/shop/hardgoods/models/browse-device.model';
import { PricingOptions } from '@support/api/common/product.interface';
import { AppConfig } from '@root/app.config';

@Wove({ moduleName: HARDGOODS_MODULE_COMPONENTS.HARDGOODS_MODULE_NAME })
@Component({
  selector: 'tmo-browse-hardgood',
  templateUrl: './browse-hardgood.component.html',
  styleUrls: [
    '../../../../../../style-sheets/components/input-radio.component.scss',
    '../../../../../../style-sheets/components/input-checkbox.component.scss',
    '../../../../../../style-sheets/components/html-spinner.component.scss',
  ],
  providers: [CurrencyPipe],
})
export class BrowseHardgoodComponent implements OnInit, OnDestroy {
  additionalChargesWithDevice(additionalChargesWithDevice: any) {
    throw new Error('Method not implemented.');
  }
  /**
   * Object to store hardgood model
   */
  @Input() public hardgoodData: BrowseDeviceModel;

  /**
   * Flag to see product price
   */
  @Input() public isSearchedProduct: boolean;

  /**
   * String to store type of billing : prepaid or postpaid
   */
  @Input() public contentData: HardgoodsContent;

  /**
   * disableCheckbox is used to disable checkbox
   */
  @Input() public disableCheckbox: boolean;

  /**
   * String to store selected credit level
   */
  @Input() public selectedCreditLevel: string;

  /**
   * disableCompareLink is used to disable compare link
   */
  @Input() public disableCompareLink: boolean;

  /**
   * on click on checkbox emits an output event emitter
   */
  @Output() public onCheck: EventEmitter<Object>;
  /**
   * To store Line In Focus
   */
  @Input() public isLineInFocus: boolean;
  /**
   * Boolean flag to check upgrade scenario
   */
  @Input() public isUpgrade: boolean;
  /**
   * Boolean flag to check upgrade scenario for line device
   */
  @Input() public isEditingUpgradeLine: boolean;
  /**
   * Boolean flag to check update scenario for now line device
   */
  @Input() public isEditingNonLineDevice: boolean;
  /**
   * holds value of p10m flag
   */
  @Input() public isP10MCustomer: boolean;
  /**
   * isCheckBoxSelected to check whether check box selected or not
   */
  public isCheckBoxSelected: boolean;
  /**
   * Holds the image URL for selected color
   */
  public imageUrl: string;
  /**
   * To store current Device Details
   */
  public currentDeviceDetails: CurrentDeviceDetails;
  /**
   * constants
   */
  public hardgoodConstants: ConfigData;
  /**
   * Stores formated strike through price value
   */
  public strikeThroughPrice: string;
  /**
   * To store current Url
   */
  public currentUrl: string;
  /**
   * will check for sale
   */
  public onSale: boolean;
  /**
   * will hold whole hardgood message
   */
  public hardGoodCotentMessage: string;
  /**
   * formated review text
   */
  public reviewsText: string;
  /**
   * Stores the pricing options for EPin scenario
   */
  public pricingOptions: PricingOptions[];

  /**
   * To store value for not/showing spinner
   */
  public isLoading: boolean;

  /**
   * Holds boolean and set to true if its web channel
   */
  // public isWebChannel: boolean;

  /**
   * Holds overriden banner text
   */
  public bannerText: string;
  /**
   * variable to show updated browse plan
   */
  // public showUpdatedBrowseDevices: boolean;
  /**
   * Holds overriden deal text
   */
  public dealText: string;
  /**
   * To store value for setTimeout fn
   */
  private loadTimeout: NodeJS.Timeout;
  /**
   * To store and show promo pricing disclaimer
   */
  public promoDisclaimer: string;
  /**
   * To store if promo pricing disclaimer is replaced with conditional enhancements disclaimer
   */
  public replacePricingDisclaimer: boolean;
  /**
   * To store if user is authenticated
   */
  @Input() private isAuthenticated: boolean;

  constructor(
    private router: Router,
    private stateStoreUtils: StateStoreUtilsService,
    private currencyPipe: CurrencyPipe,
    private compareHardgoodsService: CompareHardgoodsService,
    private commonUtilService: CommonUtilService,
    private objectService: ObjectService,
    private appConfig: AppConfig
  ) {
    this.isLoading = false;
    this.isCheckBoxSelected = false;
    this.onCheck = new EventEmitter();
    this.currentDeviceDetails = {};
  }

  /**
   * Method used to initialize data
   * @returns void
   */
  public ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.loadDefaultImages();
    // this.isWebChannel = (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.WEB);
    // this.showUpdatedBrowseDevices = (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL);
    this.hardgoodConstants = HARDGOODS_CONSTANTS;
    this.pricingOptions = this.commonUtilService.sortUtil(
      this.hardgoodData.pricingOptions,
      HARDGOODS_CONSTANTS.SKU_PRICE,
      true,
      [],
      true
    );
    let selectedItem = this.hardgoodData.itemDetails.find((deviceDetails: DeviceDetails) => {
      return deviceDetails.isDefaultSKU;
    });
    selectedItem = selectedItem ? selectedItem : this.hardgoodData.itemDetails[0];
    this.fetchcurrentDeviceDetailsData(selectedItem);
    if (this.hardgoodData.isReviewPresent) {
      this.reviewsText = this.commonUtilService.messageFormatter(this.contentData.reviews, [
        this.hardgoodData.reviewsCount.toString(),
      ]);
    } else {
      // this.reviewsText = this.isWebChannel ?  this.contentData.noReviewsText : '';
      this.reviewsText = this.contentData.noReviewsText;
    }
  }

  /**
   * @name selectColor
   * @param selectedColor object having key, name and color swatch url
   * @returns void
   * @description Method invoked on click of color swatch
   */
  public selectColor(selectedColor: number): void {
    const selectedItem = this.hardgoodData.itemDetails.find((imageDetails: DeviceDetails) => {
      return imageDetails.id === selectedColor;
    });
    if (selectedItem.imageUrl !== this.currentDeviceDetails.imageUrl) {
      const timeout = 500;
      this.loadTimeout = setTimeout(() => {
        this.toggleLoader();
      }, timeout);
    }
    this.fetchcurrentDeviceDetailsData(selectedItem);
  }

  /**
   * @name toggleLoader
   * @param loaded boolean non mandatory value for toggling the spinner
   * @returns void
   * @description Method invoked on loading the image while color switcher is clicked
   */
  public toggleLoader(loaded?: boolean): void {
    clearTimeout(this.loadTimeout);
    this.isLoading = loaded ? false : !this.isLoading;
  }

  /**
   * To check if enhancement property is to be set based on conditions for enhancement
   * @param property
   * @param enhancementProperty
   * @param selectedItem
   */
  private setEnhancement(
    property: string,
    enhancementProperty: string,
    selectedItem: DeviceDetails
  ): void {
    if (!this[property]) {
      const brand: string = this.stateStoreUtils.getBrand();
      const enhancement: ConditionalEnhancement = this.objectService.get(
        this.appConfig.getConfig('devicesPromos') || {}, 
        `${selectedItem.id}.${brand}`
      );
      if (enhancement) {
        if (
          (this.isAuthenticated && enhancement.showAuth) ||
          (!this.isAuthenticated && enhancement.showUnauth)
        ) {
          this[property] = enhancement[enhancementProperty];
        }
      }
    }
  }

  /**
   * @name fetchcurrentDeviceDetailsData
   * @returns void
   * @description Method invoked on page init and selectColorMethod
   */
  public fetchcurrentDeviceDetailsData(selectedItem: DeviceDetails): void {
    if (selectedItem) {
      this.currentDeviceDetails.imageUrl = this.objectService.get(selectedItem, 'imageUrl');
      this.onSale = this.objectService.get(selectedItem, 'hasSale');
      this.bannerText = this.objectService.get(selectedItem, 'bannerText');
      this.promoDisclaimer = this.objectService.get(selectedItem, 'bannerPLPDisclaimer');
      this.setEnhancement('bannerText', 'bannerText', selectedItem);
      this.setEnhancement('promoDisclaimer', 'bannerPLPDisclaimer', selectedItem);
      this.setEnhancement('replacePricingDisclaimer', 'replaceDisclaimer', selectedItem);
      this.dealText = this.objectService.get(selectedItem, 'dealText');
      this.currentDeviceDetails.payNowPrice = this.objectService.get(selectedItem, 'payNowPrice');
      this.currentDeviceDetails.colorName = this.objectService.get(selectedItem, 'colorName');
      this.currentDeviceDetails.strikeThroughPrice = this.objectService.get(
        selectedItem,
        'strikeThroughPrice'
      );
      this.currentDeviceDetails.averageOverallRating = this.objectService.get(
        this.hardgoodData,
        'averageOverallRating'
      );
      this.strikeThroughPrice = this.currencyPipe.transform(
        this.currentDeviceDetails.strikeThroughPrice,
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      const listPrice = this.currencyPipe.transform(
        this.objectService.get(selectedItem, 'salesPriceWithOutService'),
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      const serviceThresholdValue = this.objectService.get(selectedItem, 'serviceThresholdPrice');
      if (
        selectedItem.priceListLineId == HARDGOODS_CONSTANTS.WITH_SERVICE ||
        this.hardgoodData.isSimCard
      ) {
        this.setContentData(serviceThresholdValue, listPrice);
      }
    }
  }

  /**
   * Method is used to set aem Content Data for messages
   * @returns void
   */
  public setContentData(serviceThresholdValue: number, listPrice: string): void {
    if (this.contentData) {
      let serviceThresholdPrice = null;
      if (serviceThresholdValue) {
        serviceThresholdPrice = this.currencyPipe.transform(
          serviceThresholdValue,
          'USD',
          'symbol-narrow',
          '1.2-2'
        );
      }
      this.hardgoodConstants = HARDGOODS_CONSTANTS;
      let pricingDisclaimer = this.contentData.hardGoodContentMessageDefault;
      if (serviceThresholdPrice && listPrice) {
        pricingDisclaimer = this.contentData.hardGoodCotentMessage;
      } else if (!serviceThresholdPrice && listPrice) {
        pricingDisclaimer = this.contentData.hardGoodContentMessageNoThreshold;
      }
      if (pricingDisclaimer) {
        this.hardGoodCotentMessage = this.commonUtilService.messageFormatter(pricingDisclaimer, [
          (serviceThresholdPrice || '').toString(),
          listPrice.toString(),
        ]);
      }
    }
  }

  /**
   * Method is used to navigate to compare page
   * @returns void
   */
  public navigateToCompare(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    parsedUrl.queryParams = {};
    const baseUrl = this.router.serializeUrl(parsedUrl);
    this.compareHardgoodsService.presentState = baseUrl;
    const url = baseUrl.toString();
    if (!this.disableCompareLink) {
      this.router.navigate([url.concat(HARDGOODS_CONSTANTS.COMPARE)], {
        queryParams: {
          category:
            window[DIGITALDATA_CONSTANT.DIGITALDATA][DIGITALDATA_CONSTANT.PAGE][
              DIGITALDATA_CONSTANT.PAGEINFO
            ][DIGITALDATA_CONSTANT.PAGENAME],
        },
      });
    }
  }

  /**
   * @name goToPDP
   * @returns void
   * @description redirect to Hardgoods PDP
   */
  public goToPDP(hardGoodData: BrowseDeviceModel, scrollToReview?: boolean): void {
    this.stateStoreUtils.setProductDetails(hardGoodData.product, hardGoodData.offerId);
    this.stateStoreUtils.setProductDetails(hardGoodData.product, hardGoodData.canonicalUrl);
    this.stateStoreUtils.setSelectedColor(this.currentDeviceDetails.colorName);
    // if (!this.showUpdatedBrowseDevices || this.hardgoodData.isAccessory || this.hardgoodData.isEpin){
    if (scrollToReview) {
      this.isLineInFocus
        ? this.router.navigate(
            [
              HARDGOODS_CONSTANTS.PRODUCT_DETAILS,
              hardGoodData.canonicalUrl,
              this.objectService.get(this.currentDeviceDetails, 'colorName'),
            ],
            { queryParams: { allowEdit: true, scrollToReview: true } }
          )
        : hardGoodData.productSubType === 'SimCard'
          ? this.router.navigate([HARDGOODS_CONSTANTS.PRODUCT_DETAILS, hardGoodData.canonicalUrl], {
              queryParams: { scrollToReview: true },
            })
          : this.router.navigate(
              [
                HARDGOODS_CONSTANTS.PRODUCT_DETAILS,
                hardGoodData.canonicalUrl,
                this.objectService.get(this.currentDeviceDetails, 'colorName'),
              ],
              { queryParams: { scrollToReview: true } }
            );
    } else {
      if (this.objectService.get(this.currentDeviceDetails, 'colorName')) {
        this.router.navigate(
          [
            HARDGOODS_CONSTANTS.PRODUCT_DETAILS,
            hardGoodData.canonicalUrl,
            this.objectService.get(this.currentDeviceDetails, 'colorName'),
          ],
          {
            queryParams: {
              allowEdit: this.isLineInFocus,
              isUpgrade: this.isUpgrade,
              isEditingUpgradeLine: this.isEditingUpgradeLine,
              isEditingNonLineDevice: this.isEditingNonLineDevice,
            },
          }
        );
      } else {
        this.router.navigate([HARDGOODS_CONSTANTS.PRODUCT_DETAILS, hardGoodData.canonicalUrl], {
          queryParams: {
            allowEdit: this.isLineInFocus,
            isUpgrade: this.isUpgrade,
            isEditingUpgradeLine: this.isEditingUpgradeLine,
            isEditingNonLineDevice: this.isEditingNonLineDevice,
          },
        });
      }
    }
    // else {
    //   this.stateStoreUtils.setOfferId(hardGoodData.offerId);
    //   if (hardGoodData.productSubType.toUpperCase() === HARDGOODS_CONSTANTS.HANDSET){
    //     this.router.navigate([HARDGOODS_CONSTANTS.BROWSE_DEVICES], { queryParams: { globalSearch: true } });
    //   }
    //   else {
    //     this.router.navigate([HARDGOODS_CONSTANTS.BROWSE_TABLETS], { queryParams: { globalSearch: true } });
    //   }
    // }
  }

  /**
   * Method used to destroy data, subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {}

  /**
   * Method checking if checkbox was selected
   * @memberof BrowseHardgoodComponent
   * @returns void
   */
  public onCheckboxClicked(): void {
    this.isCheckBoxSelected = !this.isCheckBoxSelected;
    this.onCheck.emit({
      hardgood: this.hardgoodData,
      color: this.currentDeviceDetails.colorName,
      isCheckBoxSelected: this.isCheckBoxSelected,
      manufacturer: this.hardgoodData.manufacturer,
    });
  }

  /**
   * @name setDisplayModel
   * @returns void
   * @description sets the model to bind values on HTML on initial load or on click of color swatch
   */
  private loadDefaultImages(): void {
    const imageDetails = this.hardgoodData.itemDetails.find((imageDetail: DeviceDetails) => {
      return imageDetail.isDefaultSKU;
    });
    const productType = this.hardgoodData.productType;
    this.stateStoreUtils.setProductType(productType);

    this.currentDeviceDetails.imageUrl = imageDetails
      ? imageDetails.imageUrl
      : this.hardgoodData.itemDetails[0].imageUrl;
    this.currentDeviceDetails.colorSwatchId = imageDetails
      ? imageDetails.id
      : this.hardgoodData.itemDetails[0].id;
    this.currentDeviceDetails.payNowPrice = imageDetails
      ? imageDetails.payNowPrice
      : this.hardgoodData.itemDetails[0].payNowPrice;
    this.currentDeviceDetails.colorName = imageDetails
      ? imageDetails.colorName
      : this.hardgoodData.itemDetails[0].colorName;
    this.currentDeviceDetails.promotionDescription = imageDetails
      ? imageDetails.promotionDescription
      : this.hardgoodData.itemDetails[0].promotionDescription;
    this.currentDeviceDetails.availabilityStatus = imageDetails
      ? imageDetails.availabilityStatus
      : this.hardgoodData.itemDetails[0].availabilityStatus;
  }
}
